import { Input } from '@/src/common/components/Input'
import { formatCurrency } from '@/src/common/utils/general'
import { useEvent, View } from 'tamagui'

export function RefinanceForm({
  refinanceAmountString,
  onChange,
}: {
  refinanceAmountString: string
  onChange: (refinanceAmountString: string) => void
}) {
  const handleChangeRefinanceAmount = useEvent((value: string) => {
    onChange(value.replace(/[^0-9]/g, ''))
  })
  return (
    <View>
      <Input
        label="Refinance Amount"
        value={formatCurrency(refinanceAmountString, {
          decimals: 0,
          minimumFractionDigits: 0,
        })}
        onChangeText={handleChangeRefinanceAmount}
        keyboardType="numeric"
        submitBehavior="blurAndSubmit"
        returnKeyType="done"
      />
    </View>
  )
}
